module.exports = __webpack_public_path__ + "static/media/27OCHA8.e8bf7abb.jpg";